import React, { useEffect, useRef, useCallback } from "react";
import Overlay from "./../Utils/Overlay";
import { ReactComponent as CloseIcon } from "../../assets/images/cross.svg";

const PaymentIframe = ({
  url,
  close = () => { },
  setLoading = () => { },
  loading = null,
  onPaymentComplete = () => { },
}) => {
  const iframeRef = useRef(null);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, [setLoading]);

  useEffect(() => {
    if (!url) return;

    const interval = setInterval(() => {
      try {
        const iframe = iframeRef.current;
        if (!iframe) return;
        const iframeUrl = iframe.contentWindow.location.href;
        if (iframeUrl && iframeUrl !== "about:blank" && !iframeUrl.includes("paymob")) {
          clearInterval(interval);
          close();
          if (
            iframeUrl.includes("success") ||
            iframeUrl.includes("complete") ||
            iframeUrl.includes("paid")
          ) {
            onPaymentComplete();
          }
          window.top.location.href = iframeUrl;
        }
      } catch (_) {
        // Cross-origin page — keep polling.
      }
    }, 500);

    return () => clearInterval(interval);
  }, [url, close, onPaymentComplete]);

  return (
    <React.Fragment>
      {url && (
        <div
          className={
            "popup payment-popup" + (loading ? " payment-iframe--loading" : "")
          }
          style={{ height: "80% !important" }}
        >
          <CloseIcon className="popup__close" onClick={close} />
          <div className="popup__body" style={{ height: "100%", maxHeight: "100%" }}>
            <iframe
              ref={iframeRef}
              title="Payment"
              target="self"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
              className="payment-iframe"
              id="frame"
              src={url.length === 0 ? "" : url}
              frameBorder="0"
              onLoad={onLoad}
              style={{ height: "100% !important" }}
            ></iframe>
          </div>
        </div>
      )}
      {url && !loading && <Overlay darkTheme={true} handleOnClick={close} />}
    </React.Fragment>
  );
};

export default PaymentIframe;
